import { AxiosResponse } from 'axios'
import dayjs, { Dayjs } from 'dayjs'

import {
  ApiShiftQuestionnaireFilterByToken,
  ApiShiftQuestionnaires,
} from 'types/shiftQuestionnaire'

import { _axios } from './axios'

const FILTER_BY_TOKEN = '/shift_questionnaires/token'
const FILTER_BY_SECURITY_FIELD_AND_YEAR_MONTH = '/shift_questionnaires'
const FILTER_BY_UNSUBMITTED = '/shift_questionnaires/unsubmitted'
const SEND_EMAIL = '/shift_questionnaires/send_email'
const SEND_REMIND_EMAIL = '/shift_questionnaires/send_remind_email'

export const shiftQuestionnaireApi = () => {
  const filterByToken = async (
    token: string,
  ): Promise<AxiosResponse<ApiShiftQuestionnaireFilterByToken>> => {
    const response: AxiosResponse<ApiShiftQuestionnaireFilterByToken> =
      await _axios().get(FILTER_BY_TOKEN, {
        params: {
          token,
        },
      })

    response.data = {
      ...response.data,
      submittedAt:
        response.data.submittedAt && dayjs(response.data.submittedAt),
      expire: response.data.expire && dayjs(response.data.expire),
      recentAnswer: response.data.recentAnswer && {
        ...response.data.recentAnswer,
        answers: response.data.recentAnswer.answers.map((answer) => ({
          ...answer,
          date: dayjs(answer.date),
        })),
      },
    }

    return response
  }

  const filterBySecurityFieldAndYearMonth = async (
    securityFieldId: string,
    year: number,
    month: number,
  ): Promise<AxiosResponse<ApiShiftQuestionnaires>> => {
    const response: AxiosResponse<ApiShiftQuestionnaires> = await _axios().get(
      FILTER_BY_SECURITY_FIELD_AND_YEAR_MONTH,
      {
        params: {
          securityFieldId,
          year,
          month,
        },
      },
    )

    // string -> date
    response.data = {
      ...response,
      securities: response.data.securities.map((security) => ({
        ...security,
        shiftQuestionnaire: security.shiftQuestionnaire && {
          ...security.shiftQuestionnaire,
          answers: security.shiftQuestionnaire.answers.map((answer) => ({
            ...answer,
            date: dayjs(answer.date),
          })),
        },
      })),
    }
    return response
  }

  const filterByUnsubmitted = async (): Promise<
    AxiosResponse<{
      unsubmitted: {
        year: number
        month: number
        securityIds: string[]
      }[]
    }>
  > => {
    return await _axios().get(FILTER_BY_UNSUBMITTED, {
      params: {
        now: dayjs().format('YYYY-MM'),
      },
    })
  }

  const sendEmail = async (
    securityIds: string[],
    year: number,
    month: number,
    expire: Dayjs,
  ): Promise<AxiosResponse<void>> => {
    return await _axios().post(SEND_EMAIL, {
      securityIds,
      year,
      month,
      expire,
    })
  }

  const sendRemindEmail = async (
    year: number,
    month: number,
    securityIds: string[],
  ): Promise<AxiosResponse<void>> => {
    return await _axios().post(SEND_REMIND_EMAIL, {
      year,
      month,
      securityIds,
    })
  }

  return {
    filterByToken,
    filterBySecurityFieldAndYearMonth,
    filterByUnsubmitted,
    sendEmail,
    sendRemindEmail,
  }
}
